import { render, staticRenderFns } from "./codas.vue?vue&type=template&id=4c9ef460&scoped=true&"
import script from "./codas.ts?vue&type=script&lang=ts&"
export * from "./codas.ts?vue&type=script&lang=ts&"
import style0 from "./codas.scss?vue&type=style&index=0&id=4c9ef460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9ef460",
  null
  
)

export default component.exports